import {useEffect} from 'react'

import {useLocalStorage} from "../../../utils/js/useLocalStorage";
import detecktedDarkMode from "../../../utils/js/detecktedDarkMode";

import "./StyleButDarckMode.css"

import sun from "./icons/sun.svg";
import moon from "./icons/moon.svg";


function ButDarkMode() {
    const [darkMode, setDarkMode] = useLocalStorage("darkMode", detecktedDarkMode());

    useEffect(() => {
       if (darkMode === 'dark') {
           document.body.classList.add('dark');
       }else{
           document.body.classList.remove('dark');
       }
    }, [darkMode]);

    useEffect(() => {
        window
            .matchMedia("(prefers-color-scheme: dark)")
            .addEventListener("change", (event) => {
                const newColorScheme = event.matches ? "dark" : "light";
                setDarkMode(newColorScheme);
            });
    },[setDarkMode])

    const toggleDarkMode = () => {
        setDarkMode((currentValue)=>{
            return currentValue === "light" ? "dark" : "light";
        });
    }

    const butNormal ="";
    const butActive ="active";

    return (
        <div className={`header-switch-dark-mode-button theme-switch ${darkMode ==='dark'? butActive:butNormal}`} onClick={() => toggleDarkMode()}></div>
    );
}

export default ButDarkMode;